<template>
  <div>
    <list
      row-key="RetailerId"
      ref="list"
      unit="申请提现管理"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="申请提现客户" prop="TradeUnitId">
           <customer  @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
        <el-form-item label="状态" label-width="110px">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="分管部门" label-width="110px">
          <el-input size="mini" clearable v-model="params.DpId" placeholder="请选择" />
        </el-form-item> -->
        <!-- <el-form-item label="分管人员" label-width="110px">
          <el-input size="mini" clearable v-model="params.EmpId" placeholder="请选择" />
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="流水号" min-width="100px" />
        <el-table-column prop="TradeUnitName" label="申请提现的客户"/>
        <el-table-column prop="TradeUnitType" label="客户性质">
          <template slot-scope="{row}">
            <span>{{row.TradeUnitType==2?'批发':row.TradeUnitType==3?"供应商":'零售'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Amount" label="提现金额"/>
        <el-table-column prop="Status" label="状态" width="80px" align="center">
          <template slot-scope="{row}">
            <span>{{row.Status==0?'草稿':row.Status==1?"未生效":'已生效'}}</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list,tradeunitDialog,customer },
  data() {
    return {
      api: require("@/api/ba/withdrawcash").default,
      params: {
        TradeUnitName:"",
        TradeUnitId:"",
        TradeUnitType: "",
        Status: "",
      },
    };
  },
  methods: {
    setSupplier(data) {
      
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.Id
      this.params.TradeUnitName = data.Name
      this.params.TradeUnitType = data.TradeUnitType
    },
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>